import { defineComponent as _defineComponent } from 'vue'
import { useViewport } from '@travelata-libs/utils';
  import logoMax from '@/img/logos/logo-max.svg';

  interface Props {
    title?: string;
    linkUrl?: string;
    logoSrc?: string;
    logoAlt?: string;
    buttonText?: string;
    buttonTextMobile?: string;
    showIcon?: boolean;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialOfferBanner',
  props: {
    title: { default: 'Горящие туры каждый день — в нашем канале MAX' },
    linkUrl: { default: 'https://max.ru/travelata' },
    logoSrc: { default: logoMax },
    logoAlt: { default: 'travelata-max logo' },
    buttonText: { default: 'Перейти' },
    buttonTextMobile: { default: 'Подписаться' },
    showIcon: { type: Boolean, default: false }
  },
  setup(__props: any) {

  

  const { isMobile } = useViewport();

return { __sfc: true,isMobile }
}

})